<template>
  <div class="content page-component__scroll">
		<transition name="el-fade-in">
			<div id="loading" v-show="showLoading">
				<div id="loading-center">
					<div id="loading-center-absolute">
						<div class="object" id="object_one"></div>
						<div class="object" id="object_two" style="left:20px;"></div>
						<div class="object" id="object_three" style="left:40px;"></div>
						<div class="object" id="object_four" style="left:60px;"></div>
						<div class="object" id="object_five" style="left:80px;"></div>
					</div>
				</div>
			</div>
		</transition>
    <div class="banner wow animate__animated animate__fadeInUp animate__delay-0.3s">
			<el-carousel class="banner-cont" :interval="0">
				<el-carousel-item class="" v-for="(item, index) in bannerlist" :key="index">
					<img :src="item.url" >
				</el-carousel-item>
			</el-carousel>
    </div>
		<div class="about-content pa-content">
			<div class="container">
				<div class="row" style="font-size: 50px;color: #dfe7f4;font-weight: 600;padding-top: 30px;">
					about us
				</div>
				<div class="row">
					<el-row>
						<el-col :xs="24" :md="12" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="about-img">
                  <video src="../../static/images/index1/123.mp4" controls width="100%" height="420px" v-show="currlangs ==0" ></video>
                  <video src="../../static/images/index1/123e.mp4" controls width="100%" height="420px" v-show="currlangs == 1" ></video>
                  <video src="../../static/images/index1/123e.mp4" controls width="100%" height="420px" v-show="currlangs == 2" ></video>
              </div>
						</el-col>
						<el-col :xs="24" :md="12" class="about-box wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h3 style="margin: 70px 0px 30px;color: #3453ba;font-weight: 100;">{{ langs.index701 }}</h3>
							<div style="margin-bottom: 20px; color: #6983ac;">{{ langs.index15 }}</div>
							<div style="margin-bottom: 20px; color: #6983ac;">{{ langs.index16 }}</div>
							<div style="color: #6983ac;">{{ langs.index17 }}</div>
						</el-col>
					</el-row>
					<el-row style="padding-bottom: 50px;">
						<div class="about-text">
							<el-col :xs="0" :md="4" style="color: #3453ba;">1</el-col>
							<el-col :xs="12" :md="4" style="padding: 20px 0px;">
								<div style="font-size: 32px;">17</div>
								<p class="ws" style="margin: 10px 0px;font-size: 16px;" tips="专注行业17年">{{ langs.index71 }}</p>
							</el-col>
							<el-col :xs="12" :md="4" style="padding: 20px 0px;">
								<div style="font-size: 32px;">10+</div>
								<p class="ws" style="margin: 10px 0px;font-size: 16px;" tips="">{{ langs.index72 }}</p>
							</el-col>
							<el-col :xs="12" :md="4" style="padding: 20px 0px;">
								<div style="font-size: 32px;">1200</div>
								<p class="ws" style="margin: 10px 0px;font-size: 16px;" tips="">{{ langs.index73 }}</p>
							</el-col>
							<el-col :xs="12" :md="4" style="padding: 20px 0px;">
								<div style="font-size: 32px;">500+</div>
								<p class="ws" style="margin: 10px 0px;font-size: 16px;" tips="">{{ langs.index74 }}</p>
							</el-col>
							<el-col :xs="0" :md="4" style="color: #3453ba;">1</el-col>
						</div>
					</el-row>
				</div>
			</div>
		</div>
    <!-- 产品中心 -->
    <div class="pro-content pa-content mg-bottom">
      <div class="container">
        <div class="row">
          <div class="row-heading wow animate__animated animate__fadeInUp animate__delay-0.3s">
            <div style="color: #000;" tips="产品中心">{{ langs.product1 }}</div>
          </div>
          <div class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
            <p style="font-size: 25px;margin: 50px 0px 0px;" tips="">{{ langs.index75 }}</p>
          </div>
          <div class="pro-show-image row-heading wow animate__animated animate__fadeInUp animate__delay-0.3s">
            <el-col :xs="24" :md="10">
              <img src="../../static/images/index/zh/r1.png" class="pro-show-left" v-show="currlangs==0">
              <img src="../../static/images/index/eng/r1.png" class="pro-show-left" v-show="currlangs==1">
              <img src="../../static/images/index/sp/r1.png" class="pro-show-left" v-show="currlangs==2">
            </el-col>
            <el-col :xs="24" :md="14">
              <div class="pro-show-list wow animate__animated animate__fadeInUp animate__delay-0.3s">
                <img src="../../static/images/index1/r2.png" class="pro-show-right" :xs="10">
                <div class="pro-text" :xs="14">
                  <h3 tips="">{{ langs.index76 }}</h3>
                  <p tips="">{{ langs.index77 }}</p>
                  <router-link to="/products/prodetail?id=2&seq=0&index=1&name=xy轴售货机">
                    <el-button round type="primary" tips="">{{ langs.index78 }}</el-button>
                  </router-link>
                </div>
              </div>
              <div class="pro-show-list wow animate__animated animate__fadeInUp animate__delay-0.3s">
                <img src="../../static/images/index1/r3.png" class="pro-show-right">
                <div class="pro-text">
                  <h3 tips="">{{ langs.index79 }}</h3>
                  <p tips="">{{ langs.index80 }}</p>
                  <router-link to="/products/prodetail?id=0&seq=2&index=0&name=智能存餐柜">
                    <el-button round type="primary" tips="">{{ langs.index78 }}</el-button>
                  </router-link>
                </div>
              </div>
              <div class="pro-show-list wow animate__animated animate__fadeInUp animate__delay-0.3s">
                <img src="../../static/images/index1/r4.png" class="pro-show-right">
                <div class="pro-text">
                  <h3>{{ langs.index81 }}</h3>
                  <p>{{ langs.index82 }}</p>
                  <router-link to="/products/prodetail?id=0&seq=3&index=0&name=智能洗衣柜">
                    <el-button round type="primary">{{ langs.index78 }}</el-button>
                  </router-link>
                </div>
              </div>
            </el-col>
          </div>
        </div>
      </div>
    </div>
    <!-- 热门推荐 -->
    <div class="hot-content pa-content">
      <div class="" style="padding-top: 20px;">
        <div class="container">
            <el-menu :default-active="activeName" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                <el-menu-item index="0">{{ langs.index138 }}</el-menu-item>
                <el-menu-item index="1">{{ langs.index137 }}</el-menu-item>
                <el-menu-item index="2">{{ langs.index136 }}</el-menu-item>
                <el-menu-item index="3">{{ langs.index135 }}</el-menu-item>
                <el-menu-item index="4">{{ langs.index134 }}</el-menu-item>
            </el-menu>
        </div>
        <div class="hot-box">
          <div class="container" v-show="activeName == 0">
            <el-row :gutter="30">
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/a1.png" alt="">
                  <router-link to="/products/prodetail?id=0&seq=0&index=0">
                    <p class="ws">{{ langs.index83 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/a2.png" alt="">
                  <router-link to="/products/prodetail?id=2&seq=1&index=0">
                    <p class="ws">{{ langs.index84 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/a3.png" alt="">
                  <router-link to="/products/prodetail?id=0&seq=1&index=0">
                    <p class="ws">{{ langs.index85 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/a4.png" alt="">
                  <router-link to="/products/prodetail?id=0&seq=2&index=2">
                    <p class="ws">{{ langs.index86 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/a5.png" alt="">
                  <router-link to="/products/prodetail?id=0&seq=2&index=0">
                    <p class="ws">{{ langs.index87 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/a6.png" alt="">
                  <router-link to="/products/prodetail?id=1&seq=3&index=0">
                    <p class="ws">{{ langs.index88 }}</p>
                  </router-link>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="container" v-show="activeName == 1">
            <el-row :gutter="30">
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/b1.png" alt="">
                  <router-link to="/products/prodetail?id=0&seq=2&index=2">
                    <p class="ws">{{ langs.index89 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/b2.png" alt="">
                  <router-link to="/products/prodetail?id=0&seq=4&index=0">
                    <p class="ws">{{ langs.index90 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/b3.png" alt="">
                  <router-link to="/products/prodetail?id=1&seq=4&index=0">
                    <p class="ws">{{ langs.index91 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/b4.png" alt="">
                  <router-link to="/products/prodetail?id=0&seq=1&index=2">
                    <p class="ws">{{ langs.index92 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/b5.png" alt="">
                  <router-link to="/products/prodetail?id=0&seq=1&index=2">
                    <p class="ws">{{ langs.index93 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/b6.png" alt="">
                  <router-link to="/products/prodetail?id=0&seq=3&index=0">
                    <p class="ws">{{ langs.index94 }}</p>
                  </router-link>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="container" v-show="activeName == 2">
            <el-row :gutter="30">
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/c1.png" alt="">
                  <router-link to="/products/prodetail?id=2&seq=0&index=0">
                    <p class="ws">{{ langs.index95 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/c2.png" alt="">
                  <router-link to="/products/prodetail?id=2&seq=0&index=1">
                    <p class="ws">{{ langs.index96 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/c3.png" alt="">
                  <router-link to="/products/prodetail?id=2&seq=0&index=1">
                    <p class="ws">{{ langs.index96 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/c4.png" alt="">
                  <router-link to="/products/prodetail?id=2&seq=0&index=1">
                    <p>{{ langs.index96 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/c5.png" alt="">
                  <router-link to="/products/prodetail?id=2&seq=1&index=2">
                    <p class="ws">{{ langs.index97 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/c6.png" alt="">
                  <router-link to="/products/prodetail?id=2&seq=1&index=0">
                    <p class="ws">{{ langs.index98 }}</p>
                  </router-link>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="container" v-show="activeName == 3">
            <el-row :gutter="30">
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/d1.png" alt="">
                  <router-link to="/products/prodetail?id=3&seq=0&index=0">
                    <p class="ws">7{{ langs.index99 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/d2.png" alt="">
                  <router-link to="/products/prodetail?id=3&seq=0&index=1">
                    <p class="ws">10.1{{ langs.index99 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/d3.png" alt="">
                  <router-link to="/products/prodetail?id=3&seq=0&index=4">
                    <p class="ws">15.6{{ langs.index99 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/d4.png" alt="">
                  <router-link to="/products/prodetail?id=3&seq=0&index=5">
                    <p class="ws">17{{ langs.index99 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/d5.png" alt="">
                  <router-link to="/products/prodetail?id=3&seq=0&index=8">
                    <p class="ws">21.5{{ langs.index99 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/d6.png" alt="">
                  <router-link to="/products/prodetail?id=3&seq=0&index=11">
                    <p class="ws">32{{ langs.index99 }}</p>
                  </router-link>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="container" v-show="activeName == 4">
            <el-row :gutter="30">
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/e1.png" alt="">
                  <router-link to="/products/prodetail?id=4&seq=0&index=2">
                    <p class="ws">8{{ langs.index101 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/e2.png" alt="">
                  <router-link to="/products/prodetail?id=4&seq=0&index=5">
                    <p class="ws">12{{ langs.index102 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/e3.png" alt="">
                  <router-link to="/products/prodetail?id=4&seq=0&index=7">
                    <p class="ws">18{{ langs.index101 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/e4.png" alt="">
                  <router-link to="/products/prodetail?id=4&seq=0&index=13">
                    <p class="ws">{{ langs.index103 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/e5.png" alt="">
                  <router-link to="/products/prodetail?id=4&seq=0&index=1">
                    <p class="ws">{{ langs.index104 }}</p>
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="12" :md="8" class="hot-img">
                <div class="hot-img-box">
                  <img src="../../static/images/index1/hot/e6.png" alt="">
                  <router-link to="/products/prodetail?id=4&seq=0&index=14">
                    <p class="ws">{{ langs.index105 }}</p>
                  </router-link>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div style="padding: 30px 0px;margin: 0px auto;text-align: center;">
          <router-link to="/products">
            <el-button round type="primary">{{ langs.product1 }}<i class="el-icon-arrow-right" style="float:right;margin:1px 0px 0px 5px;"></i></el-button>
          </router-link>
        </div>
      </div>
    </div>
    <!-- 成功案例 -->
    <div class="success-content pa-content">
      <div class="container">
        <div class="row">
          <div class="row-heading wow animate__animated animate__fadeInUp animate__delay-0.3s">
            <div style="color: #000;font-size: 28px;font-weight: 600;padding:20px 0px 30px;">{{ langs.index106 }}</div>
          </div>
          <el-row :gutter="30">
            <el-col :xs="12" :md="6">
              <div class="success-show row-heading wow animate__animated animate__fadeInUp animate__delay-0.3s">
                <img src="../../static/images/index1/success/c1.png">
                <div class="s-tits">{{ langs.index107 }}</div>
              </div>
            </el-col>
            <el-col :xs="12" :md="6">
              <div class="success-show row-heading wow animate__animated animate__fadeInUp animate__delay-0.3s">
                <img src="../../static/images/index1/success/c2.png">
                <div class="s-tits">{{ langs.index107 }}</div>
              </div>
            </el-col>
            <el-col :xs="12" :md="6">
              <div class="success-show row-heading wow animate__animated animate__fadeInUp animate__delay-0.3s">
                <img src="../../static/images/index1/success/c3.png">
                <div class="s-tits">{{ langs.index107 }}</div>
              </div>
            </el-col>
            <el-col :xs="12" :md="6">
              <div class="success-show row-heading wow animate__animated animate__fadeInUp animate__delay-0.3s">
                <img src="../../static/images/index1/success/c4.png">
                <div class="s-tits">{{ langs.index107 }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :xs="12" :md="6">
              <div class="success-show row-heading wow animate__animated animate__fadeInUp animate__delay-0.3s">
                <img src="../../static/images/index1/success/c5.png">
                <div class="s-tits">{{ langs.index107 }}</div>
              </div>
            </el-col>
            <el-col :xs="12" :md="6">
              <div class="success-show row-heading wow animate__animated animate__fadeInUp animate__delay-0.3s">
                <img src="../../static/images/index1/success/c6.png">
                <div class="s-tits">{{ langs.index107 }}</div>
              </div>
            </el-col>
            <el-col :xs="12" :md="6">
              <div class="success-show row-heading wow animate__animated animate__fadeInUp animate__delay-0.3s">
                <img src="../../static/images/index1/success/c7.png">
                <div class="s-tits">{{ langs.index107 }}</div>
              </div>
            </el-col>
            <el-col :xs="12" :md="6">
              <div class="success-show row-heading wow animate__animated animate__fadeInUp animate__delay-0.3s">
                <img src="../../static/images/index1/success/c8.png">
                <div class="s-tits">{{ langs.index107 }}</div>
              </div>
            </el-col>
          </el-row>
          <div style="text-align: center;margin: 30px 0px 50px;">
            <router-link to="/cases">
              <el-button round type="primary">{{ langs.index108 }}<i class="el-icon-d-arrow-right" style="margin-left:5px;"></i></el-button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="iot-content pa-content">
      <div class="container">
        <div class="iot-title">{{ langs.index109 }} <span>{{ langs.index110 }}</span></div>
        <el-row>
          <el-col :xs="12" :md="8">
            <ul class="iot-nav">
              <li :class="iotactive==0?'iot-active':''" @click="changeIotNav(0)">{{ langs.index111 }}</li>
              <li :class="iotactive==1?'iot-active':''" @click="changeIotNav(1)">{{ langs.index112 }}</li>
              <li :class="iotactive==2?'iot-active':''" @click="changeIotNav(2)">{{ langs.index114 }}</li>
              <li :class="iotactive==3?'iot-active':''" @click="changeIotNav(3)">{{ langs.index115 }}</li>
              <li :class="iotactive==4?'iot-active':''" @click="changeIotNav(4)">{{ langs.index116 }}</li>
            </ul>
          </el-col>
          <el-col :xs="12" :md="16">
            <div class="right-box">
              <div class="small-title" style="font-size: 28px;margin-bottom:24px;">{{ iotlist[iotactive].title }}</div>
              <div style="font-size: 16px;line-height:28px;">
                {{ iotlist[iotactive].text }}
              </div>
              <div class="small-icon">
                <div style="margin-right: 25px;display: inline-block;text-align: center;">
                  <img src="../../static/images/index1/m1.png" alt="" style="width:50px;height:50px;">
                  <p style="font-size: 16px;margin:5px 0px;">{{ langs.index117 }}</p>
                </div>
                <div style="margin-right: 25px;display: inline-block;text-align: center;">
                  <img src="../../static/images/index1/m2.png" alt="" style="width:50px;height:50px;">
                  <p style="font-size: 16px;margin:5px 0px;">{{ langs.index118 }}</p>
                </div>
                <div style="margin-right: 25px;display: inline-block;text-align: center;">
                  <img src="../../static/images/index1/m3.png" alt="" style="width:50px;height:50px;">
                  <p style="font-size: 16px;margin:5px 0px;">{{ langs.index119 }}</p>
                </div>
                <div style="margin-right: 25px;display: inline-block;text-align: center;">
                  <img src="../../static/images/index1/m4.png" alt="" style="width:50px;height:50px;">
                  <p style="font-size: 16px;margin:5px 0px;">{{ langs.index120 }}</p>
                </div>
              </div>
              <div class="right-button">
                <router-link :to="iotlist[iotactive].tourl">
                  <el-button plain style="padding: 8px 20px;">{{ langs.index78 }}</el-button>
                </router-link>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 工厂实拍 -->
    <div class="factory-content pa-content">
      <div class="container">
        <div class="factory-title">{{ langs.index121 }}</div>
        <div>
          <img src="../../static/images/index1/s1.png" alt="" class="fac-left-img1">
          <img src="../../static/images/index1/s2.png" alt="" class="fac-right-img1">
        </div>
        <div style="margin-top: 10px;">
          <img src="../../static/images/index1/s3.png" alt="" class="fac-left-img2">
          <img src="../../static/images/index1/s4.png" alt="" class="fac-right-img2">
        </div>
      </div>
    </div>
    <!-- 成为合伙人 -->
    <div class="part-content pa-content">
      <div class="container">
        <div v-for="(item, index) in partnerlist" :key="index">
          <router-link to="/contactus">
            <img :src="item.url" alt="">
          </router-link>
        </div>
      </div>
    </div>
    <!-- 荣誉证书 -->
    <div class="honor-content pa-content">
      <div class="container">
        <div class="factory-title" style="color: #fff;">{{ langs.index122 }}</div>
        <div>
          <el-carousel :interval="4000" type="card" height="400px" style="text-align: center;">
            <el-carousel-item v-for="(item, index) in honorlist" :key="index">
              <img :src="item.url" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- 在线留言 -->
    <div class="line-content pa-content">
      <div class="container">
        <div class="factory-title" style="color: #fff;">{{ langs.index123 }}</div>
        <!-- <div> -->
        <ul class="line-type">
          <li :class="lineactive==0?'line-active':''" @click="changeLineType(0)">{{ langs.index124 }}</li>
          <li :class="lineactive==1?'line-active':''" @click="changeLineType(1)">{{ langs.index125 }}</li>
          <li :class="lineactive==2?'line-active':''" @click="changeLineType(2)">{{ langs.index126 }}</li>
          <li :class="lineactive==3?'line-active':''" @click="changeLineType(3)">{{ langs.index127 }}</li>
        </ul>
        <!-- </div> -->
        <div class="line-form">
          <el-form ref="form">
            <el-form-item label="*">
              <el-input name="linkman" v-model="formMsg.linkman" :placeholder="langs.index128"></el-input>
            </el-form-item>
            <el-form-item label="*">
              <el-input name="linktel" v-model="formMsg.linktel" :placeholder="langs.index129"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input name="email" v-model="formMsg.email" :placeholder="langs.index130"></el-input>
            </el-form-item>
            <el-form-item label="*">
              <el-input type="textarea" name="content" v-model="formMsg.content" :placeholder="langs.index131"></el-input>
            </el-form-item>
            <el-form-item label="" style="position: relative;">
              <input type="file" name="file" @change="changeImg" placeholder="" style="opacity: 0;z-index: 9;position: absolute;width: 100%;height: 38px;" />
              <el-input name="filename" v-model="formMsg.filename" :placeholder="langs.index132" style="position: absolute;top: 0px;left: 0px;"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center;margin-top: 80px;">
              <!-- @click="onSubmit" -->
              <el-button type="primary" @click="onSubmit" style="padding: 12px 50px;">{{ langs.index133 }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
	import { WOW } from 'wowjs'
	export default{
		data() {
			return{
				showLoading: true,
				bannerlist: [],
				currlangs: 1, //0中文 1英文 2西班牙语
				langs: zh,
				activeName: '0',
				bannerlist1: [
					{url: require('../../static/images/index/zh/b1.png')},
					{url: require('../../static/images/index/zh/b2.png')},
					{url: require('../../static/images/index/zh/b3.png')},
          {url: require('../../static/images/index/zh/b4.png')},
          {url: require('../../static/images/index/zh/b5.png')},
				],
				bannerlist2: [
					{url: require('../../static/images/index/eng/engb1.png')},
					{url: require('../../static/images/index/eng/engb2.png')},
					{url: require('../../static/images/index/eng/engb3.png')},
          {url: require('../../static/images/index/eng/engb4.png')},
          {url: require('../../static/images/index/eng/engb5.png')},
				],
				bannerlist3: [
					{url: require('../../static/images/index/sp/sp_banner1.png')},
					{url: require('../../static/images/index/sp/sp_banner2.png')},
					{url: require('../../static/images/index/sp/sp_banner3.png')},
					{url: require('../../static/images/index/sp/sp_banner4.png')},
				],
				product1: [],
				product11: [
					{url: require('../../static/images/index/zh/pro1-1.png')},
					{url: require('../../static/images/index/zh/pro1-2.png')},
					{url: require('../../static/images/index/zh/pro1-3.png')},
				],
				product12: [
					{url: require('../../static/images/index/eng/pro1-1.png')},
					{url: require('../../static/images/index/eng/pro1-2.png')},
					{url: require('../../static/images/index/eng/pro1-3.png')},
				],
        product2: [
          {url: require('../../static/images/index/zh/pro2-1.png')},
          {url: require('../../static/images/index/zh/pro2-2.png')},
          {url: require('../../static/images/index/zh/pro2-3.png')},
        ],
        product3: [
          {url: require('../../static/images/index/zh/pro2-1.png')},
          {url: require('../../static/images/index/zh/pro2-2.png')},
          {url: require('../../static/images/index/zh/pro2-3.png')},
        ],
				hot1: [
					{
						id:1, title:'热门推荐', list: [
							{url: require('../../static/images/index1/hot/a1.png')},
							{url: require('../../static/images/index1/hot/a2.png')},
							{url: require('../../static/images/index1/hot/a3.png')},
							{url: require('../../static/images/index1/hot/a4.png')},
							{url: require('../../static/images/index1/hot/a5.png')},
							{url: require('../../static/images/index1/hot/a6.png')},
						]
					}
				],
				honorlist: [
					{url: require('../../static/images/index1/z2.png')},
					{url: require('../../static/images/index1/z3.png')},
					{url: require('../../static/images/index1/z4.png')},
					{url: require('../../static/images/index1/z5.png')},
					{url: require('../../static/images/index1/z6.png')},
					{url: require('../../static/images/index1/z7.png')},
					{url: require('../../static/images/index1/z8.png')},
					{url: require('../../static/images/index1/z9.png')},
					{url: require('../../static/images/index1/z10.png')},
					{url: require('../../static/images/index1/z11.png')},
					{url: require('../../static/images/index1/z12.png')},
					{url: require('../../static/images/index1/z13.png')},
				],
				iotactive: 0,
				iotlist: [{id:1, title: '', text: '', tourl:''}], //
				iotlist1: [
					{id:1, title: '智能柜解决方案', text: '智能柜通过运用金属结构、工业触摸屏、扫描模块、网络连接、电控锁和管理软件等技术，保证物品的安全投递和收取。主控类型包括: 刷卡、人脸、指纹、密码，平台针对行业主流应用场景打造一系列标准化应用，快捷实现自助式应用接入，专业配置系统维护，支持二次开发，为业务稳定运行提供所需各种软硬件支持。', tourl:'/iotManage/iotdetail1'},
					{id:2, title: '售货机解决方案', text: '一台售货机同时销售多种类型商品，让顾客选择更多；多种货道类型，满足多种商品需求，让用户体验更佳，让售货机发挥更大作用；24小时自助售货，无需人工管理，超多货道容量，大大降低补货成本；前后端系统对接、软硬件一体化定制，操作简单，系统稳定；货道类型、大小、数量可根据实际需求定制；超大玻璃橱窗，商品直观可视，21.5吋大尺寸操作屏，使用简单；扫码移动支付，方便快捷；软件支持二次开发。', tourl:'/iotManage/iotdetail2'},
					{id:3, title: '智能硬件解决方案', text: '深圳市亚普达科技有限公司，专业研发人员自主研发软硬件，为智能柜解决各种技术问题并且不断的更新硬件功能，为打造更好的用户使用体验，从电磁锁到锁控板再到一体机，亚普达所用硬件基本都是自主研发制作并不断的完善强化。强大的研发实力，安全稳定可靠的系统支持。', tourl:'/iotManage/iotdetail3'},
					{id:4, title: 'MES系统解决方案', text: 'MES针对行业的品种多批量少、工艺流程复杂、信息量庞大、生产协同困难等问题，采用最新的软件、硬件、网络技术，打造了一套有效指导车间生产的解决方案，已成功应用并取得显著的成功。MES系统深度定制了亚普达--ERP的数据接口，实现ERP计划到MES执行的无缝衔接，形成高效的闭环管理，实现车间生产管理的跃升。', tourl:'/iotManage/iotdetail4'},
					{id:5, title: 'ERP系统解决方案', text: '多年来，公司贯彻“客户的需求就是硬道理”的理念，结合资深实施顾问累积的经验自主开发了“EIS3000系统”，它是亚普达ERP系列产品中用于制造行业的旗舰版本。在市场竞争更趋白热化的今天，一套完善的、由内而外的标准化服务体系是ERP的灵魂，也是我们得以安身立命的根本。面对客户的需求与问题，我们反应迅速而积极，为用户创造更多的价值。', tourl:'/iotManage/iotdetail5'}
				],
				iotlist2: [
					{id:1, title: 'Smart Cabinet Solution', text: 'Smart cabinets ensure the safe delivery and collection of items by using technologies such as metal structures, industrial touch screens, scanning modules, network connections, electronically controlled locks, and management software. The main control types include: card swiping, face, fingerprint, and password. The platform creates a series of standardized applications for mainstream application scenarios in the industry, quickly realizes self-service application access, professionally configures system maintenance, supports secondary development, and provides all necessary information for stable business operation. A variety of hardware and software support is required.', tourl:'/iotManage/iotdetail1'},
					{id:2, title: 'Vending Machine Solution', text: 'One vending machine sells multiple types of goods at the same time, allowing customers to choose more; multiple types of goods lanes to meet the needs of various goods, making the user experience better and allowing the vending machine to play a greater role; 24-hour self-service vending, no need Manual management, super multi-lane capacity, greatly reducing the cost of replenishment; front-end and back-end system docking, software and hardware integration customization, simple operation, and stable system; the type, size, and quantity of cargo lanes can be customized according to actual needs; super-large glass windows, merchandise Intuitive and visual, 21.5-inch large-size operation screen, easy to use; scan code mobile payment, convenient and fast; software supports secondary development.', tourl:'/iotManage/iotdetail2'},
					{id:3, title: 'Smart Hardware Solution', text: 'Shenzhen Yapuda Technology Co., Ltd., professional R&D personnel independently develop software and hardware, solve various technical problems for smart cabinets and constantly update hardware functions, in order to create a better user experience, from electromagnetic locks to lock control boards to For the all-in-one machine, the hardware used by Yapuda is basically independently developed and produced and continuously improved and strengthened. Strong research and development strength, safe, stable and reliable system support.', tourl:'/iotManage/iotdetail3'},
					{id:4, title: 'MES System Solution', text: 'MES has created a set of solutions to effectively guide workshop production by using the latest software, hardware, and network technology in response to the industry`s problems of many varieties and small batches, complex process flow, huge amount of information, and difficulties in production coordination. It has been successfully applied and achieved Notable success. The MES system deeply customizes the Yapuda-ERP data interface, realizes the seamless connection from ERP planning to MES execution, forms efficient closed-loop management, and realizes a leap in workshop production management.', tourl:'/iotManage/iotdetail4'},
					{id:5, title: 'ERP System Solution', text: 'Over the years, the company has carried out the concept of "customer needs are the last word", combined with the accumulated experience of senior implementation consultants, independently developed "EIS3000 system", which is the flagship version of Yapuda ERP series products for the manufacturing industry. In today`s increasingly intense market competition, a complete set of standardized service system from inside to outside is the soul of ERP and the foundation for us to live and work. Facing the needs and problems of customers, we respond quickly and actively to create more value for users.', tourl:'/iotManage/iotdetail5'}
				],

        // 合伙人
        partnerlist: [],
        partner1: [
          {url: require('../../static/images/index/zh/part1.png')},
          {url: require('../../static/images/index/zh/part2.png')},
          {url: require('../../static/images/index/zh/part3.png')},
          {url: require('../../static/images/index/zh/part4.png')},
        ],
        partner2: [
          {url: require('../../static/images/index/eng/part1.png')},
          {url: require('../../static/images/index/eng/part2.png')},
          {url: require('../../static/images/index/eng/part3.png')},
          {url: require('../../static/images/index/eng/part4.png')},
        ],
        partner3: [
          {url: require('../../static/images/index/eng/part1.png')},
          {url: require('../../static/images/index/eng/part2.png')},
          {url: require('../../static/images/index/eng/part3.png')},
          {url: require('../../static/images/index/eng/part4.png')},
        ],
				// 在线留言
				lineactive:0,
				formMsg:{
					linkman: '',
					linktel: '',
					email: '',
					content: '',
					file: '',
					filename: ''
				},

			}
		},
		created() {
			let _this = this;
			setTimeout(() => {
				_this.showLoading = false;
			}, 500)

			_this.changeMargin();// 监听屏幕宽度
			window.onresize = function(){
				_this.changeMargin();
			};
		},
		mounted() {
			let _this = this;
			_this.$nextTick(() => { // 在dom渲染完后,再执行动画
				var wow = new WOW({
					boxClass: 'wow',///动画元件css类（默认为wow）
					animateClass: 'animated',//动画css类（默认为animated）
					offset: 0,//到元素距离触发动画（当默认为0）
					mobile: true, //在移动设备上触发动画（默认为true）
					live: true//对异步加载的内容进行操作（默认为true）
				})
				wow.init()
			})

			_this.currlangs = sessionStorage.getItem('UPUS_langs');
			if(_this.currlangs == 2) {
				_this.langs = sp;
        _this.bannerlist = _this.bannerlist3; //根据屏幕宽度 修改轮播图图片
				_this.iotlist = _this.iotlist2;
				_this.product1 = _this.product12;
        _this.partnerlist = _this.partner3;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
        _this.bannerlist = _this.bannerlist2; //根据屏幕宽度 修改轮播图图片
				_this.iotlist = _this.iotlist2;
				_this.product1 = _this.product12;
        _this.partnerlist = _this.partner2;
			} else {
				_this.langs = zh;
				_this.iotlist = _this.iotlist1;
				_this.bannerlist = _this.bannerlist1; //根据屏幕宽度 修改轮播图图片
				_this.product1 = _this.product11;
        _this.partnerlist = _this.partner1;
			}
		},
		methods: {
      // iot解决方案
      changeIotNav(index) {
        this.iotactive = index;
      },
      // 在线留言
      changeLineType(index) {
        this.lineactive = index;
      },
      handleSelect(key, event) {
        // console.log(tab, event);
        console.log(key);
        this.activeName = key;
      },
      // 监听屏幕宽度
      changeMargin(){
        let _this = this;
        //获取网页可见区域宽度
        var docWidth = document.body.clientWidth;
        // console.info(docWidth);
        if(docWidth > 768){
          if(_this.currlangs == 1) {
            _this.bannerlist = _this.bannerlist3; //根据屏幕宽度 修改轮播图图片
          } else {
            _this.bannerlist = _this.bannerlist1; //根据屏幕宽度 修改轮播图图片
          }
        } else {
          _this.bannerlist = _this.bannerlist2;
        }
      },
      changeImg(e) {
        let _this = this;
        if(e.target.files[0]) {
          _this.formMsg.file = e.target.files[0];
          let na = e.target.files[0].name;
          let spread = _this.getFileExtendingName(na);
          //获取时间戳  精确到秒
          var timeStamp = Date.parse(new Date())/1000;
          //console.info(timeStamp);
          //时间戳 + 随机码 + 扩展名  生成新名称
          var newfile = timeStamp + spread;
          _this.formMsg.filename = newfile;
        }
      },
      // 提交留言
      onSubmit() {
        let _this = this;
        // console.info(_this.formMsg);
        if (!_this.formMsg.linkman || _this.formMsg.linkman==null) {
          return layer.msg('联系人不能为空');
        }
        if (!_this.formMsg.linktel || _this.formMsg.linktel==null) {
          return layer.msg('联系电话不能为空');
        }

        let mailcont = '联系人：'+_this.formMsg.linkman+' 联系电话：'+_this.formMsg.linktel+' 内容：'+_this.formMsg.content;
        console.info(mailcont);

        let formData = new FormData();
        formData.append('linkman', _this.formMsg.linkman);
        formData.append('linktel', _this.formMsg.linktel);
        formData.append('email', _this.formMsg.email);
        formData.append('content', _this.formMsg.content);
        formData.append('file', _this.formMsg.file);
        formData.append('compno', '87550091');
        formData.append('logno', 'ADMIN');
        formData.append('cateno', _this.lineactive);

        // console.info(_this.formMsg.file);
        // return

        let config = {
          headers: {
            'Content-Type': 'multipart/form-data;charset=utf-8'
          }
        }
        _this.$axios.post('upus_APP/app/lockerpal/login/postmsg/append', formData, config).then(function(result) {
          let res = result.data;
          // console.info(res);
          if(res.success == 0) {
            _this.$message({
              message: res.msg,
              type: 'error',
              offset: '150'
            });
          } else {
            _this.$message({
              message: res.msg,
              type: 'success',
              offset: '150'
            });
            _this.formMsg = {
              linkman: '',
              linktel: '',
              email: '',
              content: '',
              file: '',
              filename: ''
            };
          }
        })
          .catch(function(error) {

          })
      },
			// 获取文件后缀名
			getFileExtendingName(filename){
			  var result = (/[.]/.exec(filename))?/\.[^\.]+$/.exec(filename.toLowerCase()):'.';
			  return result;
			}
		}
	}
</script>

<style scoped>
	.banner-cont{
		height: 100%;
	}
	.row-heading{
		width: 100%;
		padding: 30px 0px 0px;
		text-align: center;
	}
	.row-heading h1{
		font-size: 40px;
		font-weight: 100;
	}
	.core-content .el-col h2{
		margin: 12px 0px;
	}

  /* IoT解决方案 */
  .iot-box-img img{
    transition: 0.3s;
  }
  .iot-box h2{
    font-size: 15px;
  }
  .iot-box:hover .iot-box-img img{
    transform: scale(1.2);
  }
  .iot-box:hover h2{
    color: #409EFF;
  }
  .iot-box:hover a{
    color: #409EFF;
  }
  /* 关于我们 */
  .about-content{
    background-color: #f2f7ff;
  }
  .about-img{
    width: 520px;
    height: 420px;
    overflow: hidden;
  }
  .about-img img{
    transition: 0.3s;
  }
  .about-img:hover img{
    transform: scale(1.05);
  }
  .about-box{
    text-align: left;
    margin-bottom: 50px;
  }
  .about-box h3{
    font-size: 24px;
    margin: 0px 0px 20px;
  }
  .about-box h3 span{
    font-size: 18px;
    margin-left: 5px;
    color: #888;
    font-weight: 100;
  }
  .about-box div{
    line-height: 22px;
  }
  .about-box .el-button{
    margin-top: 20px;
  }

  /* 智能一体化管理 */
  .mg-bottom{
    margin-bottom: 50px;
  }
  .more-box h2{
    color: #1841b5;
    font-weight: 300;
    font-size: 28px;
    margin: 15px 0px 12px;
  }
  /* 产品 */
  .pro-content .row-heading h1{
    margin-bottom: 12px;
  }
  .pro-content .row-heading div{
    font-size: 24px;
    /* color: #999; */
  }
  .pro-text{
    width: 350px;
    display: block;
    float: left;
    margin-left: 50px;
    color: #000;
    text-align: left;
  }
  .pro-text h3{
    font-weight: 100;
  }
  .pro-text p{
    font-size: 16px;
  }
  .pro-item1 img{
    width: 600px;
  }
  .pro-item2 img{
    width: 300px;
  }
  /* 案例 */
  .pro-case-list img{
    width: 240px;
    height: 240px;
  }
  .pro-case-list h3{
    margin: 10px 0px 5px;
  }
  .case-layer span{
    font-size: 16px;
  }
  .case-layer h2, .case-layer div{
    opacity: 1;
    color: #fff;
    transition: 0.5s;
  }
  .case-layer div{
    padding: 6px 0px;
  }
  .pro-case-list:hover img{
    opacity: 0.2;
  }
  .pro-case-list:hover .case-layer > div{
    margin-top: 30%;
    opacity: 1;
  }
  /* 定制流程 */
  .flow-list .el-col i{
    position: absolute;
    top: 90px;
    right: -10px;
    font-size: 24px;
    color: #1841b5;
  }

  .flow-list img{
    transition: 1s;
  }
  .flow-list .el-col:hover img{
    transform: rotateZ(360deg);
  }
  .flow-list .el-col:hover h3{
    color: #409EFF;
  }
  /* 热门推荐 */
  .hot-content{
    background-color: #f2f7ff;
  }
  .hot-img-box{
    padding: 20px;
    margin-bottom: 20px;
    background-color: #fff;
  }
  .hot-img-box p{
    color: #409EFF;
    font-size: 15px;
    margin: 0px;
    padding-top: 10px;
    border-top: 1px solid #eee;
  }
  .hot-img-box p:hover{
    color: #f00;
  }
  .success-show{
    position: relative;
  }
  .success-show p{
    position: absolute;
    right: 10px;
    bottom: 0px;
    color: #409EFF;
    cursor: pointer;
    font-size: 13px;
    padding: 3px 10px;
    background-color: #fff;
    border-radius: 5px;
  }
  .success-show p i{
    font-size: 14px;
    margin-left: 5px;
  }
  .s-tits{
    position: absolute;
    left: 10px;
    top: 40px;
    border: 1px solid #fff;
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
  }
  /* 解决方案示例 */
  .iot-content{
    height:650px;
    background-image: url('../../static/images/index1/58.png');
    background-size: 100% 100%;
  }
  .iot-title{
    text-align: center;
    font-size: 28px;
    color: #fff;
    padding: 30px 0px 40px;
  }
  .iot-title span{
    margin-left: 15px;
  }
  .iot-nav::before{
    width: 240px;
    height: 500px;
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    opacity: 0.3;
    background-color: #fff;
    z-index: -1;
  }
  .iot-nav{
    width: 240px;
    margin: 0px auto;
    position: absolute;
    left: 0px;
    top: 0px;
    color: #fff;
    text-align: left;
    padding: 40px 0px 0px;
    z-index: 9;
  }
  .iot-nav li{
    margin: 0px 8px;
    padding: 10px 20px;
    font-size: 18px;
    z-index: 9;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.5s;
  }
  .iot-nav li.iot-active{
    background-color: #1841b5;
    z-index: 9;
  }
  .right-box::before{
    width: 100%;
    height: 500px;
    position: absolute;
    left: -35px;
    top: 0px;
    content: '';
    text-align: left;
    background-color: #fff;
    opacity: 0.1;
    z-index: -1;
    padding: 0px 15px;
  }
  .right-box{
    position: absolute;
    left: 280px;
    top: 0px;
    color: #fff;
    text-align: left;
    z-index: 9;
    padding-top: 50px;
  }
  .small-icon{
    margin: 30px 0px 20px;
    border-bottom: 1px solid #8b9299;
    padding: 12px 0px;
  }
  /* 工厂实拍 */
  .factory-title{
    text-align: center;
    font-size: 28px;
    padding: 30px 0px 40px;
  }
  /* 合伙人 */
  .part-content{

  }
  /* 荣誉证书 */
  .honor-content{
    height: 550px;
    margin: 30px 0px 0px;
    background: url('../../static/images/index1/z1.png');
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 400px;
    margin: 0;
  }
  /* 在线留言 */
  .line-content{
    height:600px;
    background: url('../../static/images/index1/y1.png');
  }
  .line-type{
    width: 200px;
    height: 400px;
    padding-top: 10px;
    background-color: #fff;
    float: left;
  }
  .line-type li{
    margin: 5px;
    padding: 10px 0px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    text-align: center;
    cursor: pointer;
  }
  .line-type li.line-active{
    color: #1841b5;
  }
  .about-text{
    width:100%;
    height:120px;
    background-color: #3453ba;
    color: #fff;
  }
  .pro-show-image{
    height: 750px;
  }
  .pro-show-left{
    width: 450px;
    height: 720px;
  }
  .pro-show-list{
    width: 100%;
    height: 240px;
    padding-left: 20px;
  }
  .pro-show-right{
    width: 220px;
    height: 220px;
    float: left;
  }
  .fac-left-img1{
    width: 660px;
    height: 400px;
    margin-right: 10px;
  }
  .fac-right-img1{
    width: 500px;
    height: 400px;
  }
  .fac-left-img2{
    width: 660px;
    height: 560px;
    margin-right: 10px;
  }
  .fac-right-img2{
    width: 500px;
    height: 560px;
  }
  .honor-content img{
    width: 320px;
    height: 400px;
  }
  .line-form{
    display: inline-block;
    margin-left: 150px;
    width: 500px;
  }
  @media screen and (max-width: 768px) {
    .line-form{
      display: block;
      margin: 0px auto;
      width: 320px;
    }
    .honor-content{
      height: 400px;
      overflow: hidden;
    }
    .honor-content img{
      width: 180px;
      height: 240px;
    }
    .fac-left-img1{
      width: 100%;
      height: 100%;
    }
    .fac-right-img1{
      width: 100%;
      height: 100%;
    }
    .fac-left-img2{
      width: 100%;
      height: 100%;
    }
    .fac-right-img2{
      width: 100%;
      height: 100%;
    }
    .pro-text{
      width: 200px;
      margin-left: 10px;
    }
    .pro-text h3{
      font-size: 16px;
    }
    .pro-text p{
      font-size: 13px;
    }
    .pro-show-right{
      width:150px;
      height: 150px;
      float: left;
    }
    .banner-cont{
      height: 140px;
    }
    .banner-cont img{
      height: 140px;
    }
    .about-text{
      width:100%;
      height:240px;
      background-color: #3453ba;
      color: #fff;
    }
    .pro-show-image{
      height: 1150px;
    }
    .pro-show-left{
      width: 100%;
      height: 100%;
    }
    .pro-show-list{
      width: 100%;
      height: 180px;
      padding-left: 0px;
    }
    .container{
      overflow: hidden;
    }
    .iot-content{
      display: none;
    }
    .line-type{
      float: none;
      height: auto;
      width: 100%;
      background-color: unset;
      margin-bottom: 20px;
      padding: 0px 18px;
    }
    .line-type li{
      font-size: 13px;
      display: inline-block;
      border: 0px;
      background-color: #fff;
      padding: 5px 10px;
      border-radius: 5px;
    }
    .line-type li.line-active{
      color: #1841b5;
    }
    .flow-title2 .el-divider__text{
      font-size: 14px;
    }
    .flow-cont img{
      width: 100%;
    }
    .flow-list .el-col{
      padding: 15px;
    }
    .flow-list .el-col h3{
      font-size: 14px;
    }
    .flow-list .el-col i{
      top: 50px;
      right: -12px;
    }
    .flow-list .el-col i.ishide{
      display: none;
    }
    div.fr-tit{
      width: 100%;
      display: block;
      float: left;
      font-size: 13px;
      margin-top: 5px;
      text-align: left;
    }
    .pro-cont-title{
      height: 50px;
    }
    .mg-bottom{
      margin-bottom: 30px;
    }
    .pro-cont1{
      height: 240px;
    }
    .pro-item1 img{
      width: 330px;
    }
    .pro-cont2{
      height: 300px;
    }
    .pro-item2 img{
      width: 180px;
    }
    .about-img{
      width: 100%;
      height: 100%;
    }
    .about-box h3{
      margin: 0px 0px 12px;
    }
    .el-row.mg-bottom{
      margin-bottom: 30px;
    }
    .iot-box{
      margin-bottom: 0px;
    }
    .iot-img-x{
      margin: 20px 0px;
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/index.vue